import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { TranslationLoadedService } from "../services/TranslationLoadedService";
import { catchError, forkJoin, map, merge, Observable, of } from "rxjs";

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return 'some value';
  }
}
export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, private translationLoaded: TranslationLoadedService) { }

  public getTranslation(lang: string): Observable<any> {
    const resources: string[] = [lang + '.json'];

    const requests = resources.map(resource => {
      const path = 'assets/i18n/' + resource;
      return this.http.get(path).pipe(
        catchError(res => {
          console.error('Something went wrong for the following translation file:', path);
          console.error(res.message);
          return of({});
        })
      );
    });
    return forkJoin(requests).pipe(
      map(response => {
        this.translationLoaded.loaded$().next();
        return Object.assign({}, ...response);
      })
    );
  }
}
